module.exports = __webpack_public_path__ + "static/media/homeinoak-IG.c388121a.PNG";